import http from "@/utils/http";
import { getTokenToLocalStorage } from "@/utils/token";
export async function* readStreamDataIncrementally(response) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      console.log(line, "line测试");
      if (line.startsWith("data:")) {
        try {
          const jsonData = JSON.parse(line.slice(5).trim());
          console.log(jsonData, "jsonData");
          // const status = jsonData.Response?.Status?.status;
          // const total = jsonData.Response?.Status?.total;
          // console.log(jsonData);
          yield jsonData;

          // if (status === 1 || status === 2 || total === 0) {
          //   console.log("检测到停止条件，立即结束");
          //   return;
          // }

          // if (total === 1 && jsonData.Response?.item) {
          //   console.log("total 为 1 且含有 Timeline 数据，停止并返回");
          //   return;
          // }
        } catch (error) {
          console.error("数据解析失败:", error, "出错的数据:", line);
        }
      } else {
        console.log("跳过非 data 行:", line);
      }
    }
  }
}

// export const getImageText = async () => {
//   try {
//     const result = await http.post(`/api/v1/editing/image_text`, {
//       "session_id": 250,
//       "data": `{"scenes":[{"comment":"场景一，注释字段， 后所有comment功能相同","images":[{"media_id":"8b3d2b50d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8b032f90d6f871ef8244e7f7f4586301","width":1920,"height":1080},{"media_id":"8aeb61d0d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8adf2cd0d6f871efbfa1f6f7c77a6301","width":1920,"height":1080}],"collages":[{"img_num":3,"frames":[{"x":0,"y":0,"width":500,"height":250},{"x":0,"y":250,"width":250,"height":250},{"x":250,"y":250,"width":250,"height":250}]},{"img_num":4,"frames":[{"x":0,"y":0,"width":250,"height":250},{"x":250,"y":0,"width":250,"height":250},{"x":0,"y":250,"width":250,"height":250},{"x":250,"y":250,"width":250,"height":250}]}]},{"comment":"场景一，注释字段， 后所有comment功能相同","images":[{"media_id":"8a333560d6f871ef898ff6f7c6696301","width":1920,"height":1080},{"media_id":"8a9d8ff0d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8a929370d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8a37a230d6f871ef898ff6f7c6696301","width":1920,"height":1080}],"collages":[{"img_num":3,"frames":[{"x":0,"y":0,"width":500,"height":250},{"x":0,"y":250,"width":250,"height":250},{"x":250,"y":250,"width":250,"height":250}]},{"img_num":2,"frames":[{"x":0,"y":0,"width":250,"height":250},{"x":250,"y":0,"width":250,"height":250}]}]}],"global":{"comment":"全局配置","enabled":false,"content":{"comment":"内容同scenes元素"}},"settings":{"title":"夏天怎么少的了冰可乐","keyworkds":"夏天、可乐、神清气爽","type":"好物安利","style":["风趣幽默","商务正式"],"text_len":200,"max_generate":20}}`,
//       "aspect": "9：16"
//   });
//     return result.data;
//   } catch (error) {
//     console.error("Error fetching upload token:", error);
//     throw error;
//   }
// };

export async function* getImageText(data): AsyncGenerator<any> {
  const token = getTokenToLocalStorage();
  // {
  //   "session_id": 250,
  //   "data": `{"scenes":[{"comment":"场景一，注释字段， 后所有comment功能相同","images":[{"media_id":"8b3d2b50d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8b032f90d6f871ef8244e7f7f4586301","width":1920,"height":1080},{"media_id":"8aeb61d0d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8adf2cd0d6f871efbfa1f6f7c77a6301","width":1920,"height":1080}],"collages":[{"img_num":3,"frames":[{"x":0,"y":0,"width":500,"height":250},{"x":0,"y":250,"width":250,"height":250},{"x":250,"y":250,"width":250,"height":250}]},{"img_num":4,"frames":[{"x":0,"y":0,"width":250,"height":250},{"x":250,"y":0,"width":250,"height":250},{"x":0,"y":250,"width":250,"height":250},{"x":250,"y":250,"width":250,"height":250}]}]},{"comment":"场景一，注释字段， 后所有comment功能相同","images":[{"media_id":"8a333560d6f871ef898ff6f7c6696301","width":1920,"height":1080},{"media_id":"8a9d8ff0d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8a929370d6f871efbfa1f6f7c77a6301","width":1920,"height":1080},{"media_id":"8a37a230d6f871ef898ff6f7c6696301","width":1920,"height":1080}],"collages":[{"img_num":3,"frames":[{"x":0,"y":0,"width":500,"height":250},{"x":0,"y":250,"width":250,"height":250},{"x":250,"y":250,"width":250,"height":250}]},{"img_num":2,"frames":[{"x":0,"y":0,"width":250,"height":250},{"x":250,"y":0,"width":250,"height":250}]}]}],"global":{"comment":"全局配置","enabled":false,"content":{"comment":"内容同scenes元素"}},"settings":{"title":"夏天怎么少的了冰可乐","keyworkds":"夏天、可乐、神清气爽","type":"好物安利","style":["风趣幽默","商务正式"],"text_len":200,"max_generate":20}}`,
  //   "aspect": "9：16"
  // }
  const res = await fetch(`/api/v1/editing/image_text`, {
    method: "POST",
    headers: {
      Token: `${token}`,
      "content-type": "application/json;charset=UTF-8",
      Aid: process.env.REACT_APP_AID,
    },
    body: JSON.stringify(data),
  });
  if (res.status === 400) {
    // return new Promise.reject()
    const error = await parseReadableStreamToString(res.body);
    return Promise.reject(error);
  }

  for await (const jsonData of readStreamDataIncrementally(res)) {
    yield jsonData;
  }
}

export async function parseReadableStreamToString(
  body: ReadableStream
): Promise<string> {
  const reader = body.getReader(); // 获取流的读取器
  const decoder = new TextDecoder("utf-8"); // 使用 UTF-8 解码器
  let result = ""; // 用于存储解析后的数据

  try {
    const { value, done } = await reader.read(); // 读取流中的数据
    if (done) {
      console.log("Stream reading completed.");
    }
    // 将读取到的数据解码为字符串并追加到结果
    result += decoder.decode(value, { stream: true });
  } catch (error) {
    console.error("Error while reading stream:", error);
    throw error; // 如果发生错误，抛出异常
  }

  return result; // 返回完整的解析结果
}

export interface ICompositionTaskInitRequest {
  session_id: number;
  folder_id: number;
  aspect: string;
  width: string | number;
  height: number | string;
  project_id: number;
}

// 图文初始化任务
export const ImageTaskInit = async (
  data: ICompositionTaskInitRequest
): Promise<string> => {
  const result = await http.post(`/api/v1/editing/image_text/task/init`, {
    ...data,
  });
  return result.data.task_id;
};

//

// 新建子任务任务
export const compositionCreateSubTask = async (
  data
) => {
  const res = await http.post(`/api/v1/editing/image_text/task/submit`, {
    ...data,
  });
  return res
};

// 提交完成的任务
export const submitFinishedTask = async (data: { task_id: string }) => {
  await http.post(`/api/v1/editing/image_text/task/finish`, {
    ...data,
  });
};


// 图文单个data更新
export const editImageApi = async (
  id: number | string,
  data: any
): Promise<string> => {
  const result = await http.put(`/api/v1/editing/image_text/${id}`, {
    data: JSON.stringify(data),
  });
  return result.data;
};
const toBaseUrlSetItem = <T extends Object>(
  data: T[],
  baseUrl: string,
  key: string
) => {
  return data.map((item) => {
    return {
      ...item,
      url: baseUrl + item[key],
    };
  });
};
const toBaseUrlSetItem1 = <T extends Object>(
  data: T[],
  baseUrl: string,
  key: string
) => {
  return data.map((item) => {
    return {
      ...item,
      url: baseUrl + "/" + item[key],
    };
  });
};
// 获取花字
export const getFlowerApi = async (params) => {
  const result = await http.get(`/api/v1/editing/image_text/flower_effect`, {
    params,
  });
  return {
    data: toBaseUrlSetItem(result.data.items, result.data.base_url, "cover"),
  };
};

// 获取字体
export const getFontsApi = async () => {
  const result = await http.get(`/api/v1/editing/fonts`);
  return {
    data: toBaseUrlSetItem1(result.data.items, result.data.base_url, "url"),
  };
};

// 获取宫格
export const getCollagesApi = async (params) => {
  const result = await http.get(`/api/v1/editing/image_text/collages`, {
    params,
  });
  return result.data;
};

// 图集子合成子任务详情
//   GET /editing/image_text/task/sub/{id}
//   接口ID：275360629
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-275360629
export const getTaskSubApi = async (id) => {
  const result = await http.get(`/api/v1/editing/image_text/task/sub/${id}`);
  return result.data
};

// 图文生成分享链接
// POST /video/task/image/url
// 接口ID：275473186
// 接口地址：https://app.apifox.com/link/project/4770011/apis/api-275473186
export const getImageUrlApi = async (data) => {
  const result = await http.post(`/api/v1/video/task/image/url`, {
    ...data,
  });
  return result.data
};
